// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1qmmf","toolbar":"styles_toolbar__2lvyW","editor":"styles_editor__HvpA6"};